import * as Yup from 'yup';

export const schema = Yup.object().shape({
  folder_name: Yup.string()
    .required('folder_name.required')
    .max(255, 'folder_name.max')
    .matches(/^[a-zA-Z0-9-_ ]*$/, 'folder_name.invalid'),
});
